import { Button, Group, Paper, Stack, Text } from "@mantine/core";
import { IconMoodWrrr } from "@tabler/icons-react";

function Fallback() {
  return (
    <Paper withBorder m="md" p="md">
      <Stack>
        <Group mt="md">
          <IconMoodWrrr size={50} />
          <Text fz="xl">Uh-oh...</Text>
        </Group>
        <Text mt="lg">
          Sorry about that, something went wrong! Our team has been notified and
          will look into the error.
        </Text>
        <Button variant="default" onClick={() => window.location.reload()}>Reload page</Button>
      </Stack>
    </Paper>
  );
}

export default Fallback;
